import React from 'react';

import DocumentPreview from 'components/common/DocumentPreview/DocumentPreview';
import { HFS_PRIVACY_POLICY_URL } from 'constants/constants';

import styles from './TermsOfUse.module.scss';

const TermsOfUse = () => {
  return (
    <DocumentPreview title="Terms of use">
      <p className={styles.title}>ACCEPTANCE OF TERMS OF USE:</p>
      <p className={styles.bodyText}>
        HFS Financial, LLC and any affiliated entities (the “Company”) requires that all visitors (“you”) to the Company
        website (
        <a className={styles.link} href="https://www.hfsfinancial.net" target="_blank" rel="noopener noreferrer">
          www.hfsfinancial.net
        </a>
        ) (“Site”) abide by the following Terms of Use (“TOU”). By accessing and using the Site you indicate your
        agreement to these TOU.{' '}
        <span className={styles.boldText}>IF YOU DO NOT AGREE TO THESE TOU, PLEASE DO NOT ACCESS OR USE THE SITE.</span>{' '}
        Company reserves the right to modify these TOU at any time and in any manner, without prior notice.
      </p>
      <p className={styles.title}>RIGHTS:</p>
      <p className={styles.bodyText}>
        Company owns this Site and Company, or its content providers, own and/or retain the rights to all content, Web
        pages, source code, materials, data, information, text, screens, services, design, layout, screen interfaces,
        “look and feel”, logo or graphic images appearing herein, and the operation of this Site (collectively,
        “Materials”), which are protected by various intellectual property laws, including, but not limited to,
        copyrights, patents, trade secrets, trademarks, and service marks. Nothing in these TOU transfers any rights in
        the Materials to you or any third party and you acknowledge and agree that you do no not acquire any ownership
        rights by downloading or viewing any Materials.
      </p>
      <p className={styles.title}>PRIVACY:</p>
      <p className={styles.bodyText}>
        For information concerning how Company uses information you provide through the Site, please review Company’s
        Privacy Policy, available{' '}
        <a href={HFS_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
          HERE
        </a>
        .
      </p>
      <p className={styles.title}>USE LIMITATION:</p>
      <p className={styles.title}>No Unlawful or Prohibited Use</p>
      <p className={styles.bodyText}>
        As a condition of your use of the Site, you acknowledge and agree that you will not use the Site for any purpose
        that is unlawful or otherwise prohibited by these TOU. You will not use the Site in any manner that could
        damage, disable, overburden, or impair the Site or any related service provider server, or the network(s)
        connected to the Site or any related service provider server, or interfere with any other party's use and
        enjoyment of the Site.
      </p>
      <p className={styles.title}>LINKING:</p>
      <p className={styles.bodyText}>
        A link to a linked website (“Linked Site”) on this Site does not mean that Company endorses or accepts any
        responsibility for the content, functioning or use of such Linked Site, and you enter any such website at your
        own risk. You agree that Company has no control over or liability for information on Linked Sites. You should be
        aware that Linked Sites may contain rules and regulations, privacy provisions, confidentiality provisions, and
        other provisions that are different from the provisions provided on this Site. Company is not responsible for
        such provisions, and expressly disclaims any and all liability related to such provisions. Company prohibits
        unauthorized hypertext links to this Site, or the framing of this Site.
      </p>
      <p className={styles.title}>DISCLAIMER OF WARRANTIES:</p>
      <p className={styles.bodyText}>
        THE SITE AND ALL OTHER INFORMATION OR SERVICES AVAILABLE ON THIS SITE, INCLUDING TEXT, IMAGES, AND LINKS, AND
        THE INFORMATION ON ANY LINKED SITE, WHETHER AFFILIATED OR UNAFFILIATED WITH COMPANY, WHICH YOU MAY VISIT THROUGH
        THIS SITE, ARE PROVIDED “AS IS,” “WHERE IS,” AND “AS AVAILABLE,” BY COMPANY, AS A CONVENIENCE TO ALL USERS
        WITHOUT REPRESENTATION OR WARRANTY OF ANY KIND INCLUDING, BUT NOT LIMITED TO, ANY EXPRESS OR IMPLIED WARRANTIES
        (I) OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE; (II) OF INFORMATIONAL CONTENT OR ACCURACY; (III) OF
        NON-INFRINGEMENT; (IV) OF QUIET ENJOYMENT; (V) OF TITLE; (VI) THAT THIS SITE OR ANY SERVICES WILL OPERATE ERROR
        FREE, OR IN AN UNINTERRUPTED FASHION; (VII) THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR (VIII) THAT THIS
        SITE IS COMPATIBLE WITH ANY PARTICULAR HARDWARE OR SOFTWARE PLATFORM. EFFORTS BY COMPANY TO MODIFY THE SITE
        SHALL NOT BE DEEMED A WAIVER OF THESE LIMITATIONS. THE SITE COULD INCLUDE TECHNICAL INACCURACIES OR
        TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN. COMPANY AND/OR ITS SERVICE
        PROVIDERS MAY MAKE CHANGES IN THE SITE AT ANY TIME AND FROM TIME TO TIME.
      </p>
      <p className={styles.title}>LIMITATION OF LIABILITY:</p>
      <p className={styles.bodyText}>
        COMPANY SHALL NOT BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY LOSS OF PROFITS, LOSS OF USE, LOSS OF DATA,
        INTERRUPTION OF BUSINESS, OR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND
        HOWSOEVER CAUSED, WHETHER ARISING UNDER THESE TOU, FROM USE OF THE SITE OR OTHERWISE, EVEN IF COMPANY WAS
        ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR WAS NEGLIGENT. THIS LIMITATION ON LIABILITY INCLUDES, BUT IS NOT
        LIMITED TO, THE TRANSMISSION OF ANY VIRUSES THAT MAY INFECT A USER'S EQUIPMENT, FAILURE OF MECHANICAL OR
        ELECTRONIC EQUIPMENT OR COMMUNICATION LINES, TELEPHONE OR OTHER INTERCONNECT PROBLEMS, UNAUTHORIZED ACCESS,
        THEFT, OPERATOR ERRORS, STRIKES OR OTHER LABOR PROBLEMS OR ANY FORCE MAJEURE EVENT. IN JURISDICTIONS THAT
        PROHIBIT THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, COMPANY’S LIABILITY
        IS LIMITED TO THE GREATEST EXTENT PERMITTED BY THE LAW.
      </p>
      <p className={styles.title}>TERMINATION:</p>
      <p className={styles.bodyText}>
        Company reserves the right to discontinue providing and/or to terminate your access to the Site or any portion
        thereof at any time.
      </p>
      <p className={styles.title}>GOVERNING LAW AND INTERNATIONAL USE:</p>
      <p className={styles.bodyText}>
        This Site only is directed to persons in the continental United States, Hawaii and Alaska, however, it may be
        accessed from many different places around the world. By accessing this Site, you agree that the statutes and
        laws of the State of Maryland, without regard to any conflicts of laws principles that would apply the law of
        another jurisdiction, will apply to all matters relating to the use of this Site. You further agree that
        exclusive jurisdiction for all disputes, claims or controversies relating to use of this Site shall be only in a
        federal or state court with competent jurisdiction in the State of Maryland, City of Baltimore. You irrevocably
        consent to the exercise of personal jurisdiction by such courts in any such dispute, claim or controversy and
        irrevocably waive any objection on the ground of venue or the convenience of the forum. Any judgment entered in
        any such dispute, claim or controversy may be enforced in other jurisdictions in any manner provided by law.
        Those who choose to access this Site from other locations do so on their own initiative and are responsible for
        compliance with local laws.
      </p>
      <p className={styles.title}>FEEDBACK:</p>
      <p className={styles.bodyText}>
        To the extent permitted by applicable law, any comments or materials (“Feedback”) sent to Company including
        questions, suggestions, ideas, comments, or the like relating to this Site shall be deemed to be
        non-confidential and shall become the property of Company upon receipt. Company shall have no obligation of any
        kind with respect to such Feedback and shall be free to transmit, reproduce, use, exhibit, disclose, display,
        transform, copyright, create derivative works, and distribute the Feedback to others without limitation.
        Further, Company shall be free to use any ideas, concepts, know-how and techniques contained in such Feedback
        for any purpose whatsoever, including but not limited to, developing, manufacturing and marketing products or
        services incorporating such information.
      </p>
      <p className={styles.title}>ACCESS BY CHILDREN:</p>
      <p className={styles.bodyText}>
        The Site is intended for use by adults who are actual or potential purchasers of Company products and services.
        The Site is not directed at children. Company does not target or market to, and the Site is not intended for use
        by, children under the age of 13. Company does not knowingly and will not intentionally contact or request
        personal information from children under the age of 13 for marketing purposes. However, the Site does not filter
        ads or other material children may view through the Site or linked sites, some of which may be inappropriate for
        children.
      </p>
      <p className={styles.title}>CALL MONITORING AND RECORDING; FRAUD PREVENTION; CONTACT:</p>
      <p className={styles.bodyText}>
        You consent to call monitoring and recording, for purposes that include but are not limited to training, quality
        assurance, and/or risk management, of any call between you and Company. You authorize your wireless carrier to
        use or disclose information about your account and your wireless device, if available, to Company or its service
        providers for the duration of your business relationship with Company, solely to help them identify you or your
        wireless device and to prevent fraud. See our Privacy Policy for how we treat your data, available{' '}
        <a href={HFS_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
          HERE
        </a>
        . By voluntarily providing Company with your phone numbers and/or email addresses, you expressly authorize
        Company and/or participating lenders to communicate with you regarding your inquiry at the phone numbers
        (including mobile device numbers) and email addresses you provide, including through the use of automated
        dialing/messaging systems and/or pre-recorded voice messages.
      </p>
      <p className={styles.title}>MISCELLANEOUS:</p>
      <p className={styles.bodyText}>
        These TOU constitute the entire agreement between you and Company and supersede all prior or contemporaneous
        communications, promises and proposals, whether oral, written or electronic, between you and Company with
        respect to this Site. If any part of these TOU is determined to be invalid or unenforceable pursuant to
        applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth
        above, then the invalid or unenforceable provision will be deemed superseded by a valid enforceable provision
        that most closely matches the intent of the original provision, and the remainder of these TOU shall continue in
        effect. A printed version of these TOU and of any notice given in electronic form shall be admissible in
        judicial or administrative proceedings based upon or relating to these TOU to the same extent and subject to the
        same conditions as other business documents and records originally generated and maintained in printed form. All
        rights not expressly granted herein are reserved.
      </p>
      <p className={styles.title}>For More Information</p>
      <p className={styles.bodyText}>
        If you have any comments, concerns or questions regarding these TOU, please contact us at (800) 254-9560 or by
        email at{' '}
        <a className={styles.link} href="mailto:info@hfsfinancial.net" target="_blank" rel="noopener noreferrer">
          info@hfsfinancial.net
        </a>
        .
      </p>
    </DocumentPreview>
  );
};

export default TermsOfUse;
